import {makeStyles, Button, Link} from "@fluentui/react-components";
import React, {useEffect, useState} from "react";
import {useMailService, useUserService} from "../../utils/services/http.service";

const useStyles = makeStyles({
    root: {
        alignItems: "stretch",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        rowGap: "12px",
    },
    message: {
        width: "100%",
        maxWidth: "100%",
        textAlign: "center",
        overflowWrap: "anywhere",
    },
    validateButton: {
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        height: "auto",
        whiteSpace: "normal",
        marginTop: "10px",
    }
});

const Connexion: React.FC = () => {
    const styles = useStyles();
    const userService = useUserService();
    const mailService = useMailService();

    const generateUniqueToken = (): string => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const tokenLength = 30;
        let token = '';

        for (let i = 0; i < tokenLength; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            token += characters[randomIndex];
        }

        return token;
    };

    const [idDemande, setIdDemande] = React.useState("");
    const [isPolling, setIsPolling] = useState(false);
    const [success, setSuccess] = useState(false);

    const startLoginWorkflow = async () => {
        try {
            const result = await mailService.verifierAuthentification();
            if (result.succes) {
                setSuccess(true);
                localStorage.setItem("zLawyerToken", result.message);
            }
        } catch (error) {
            console.error("Error calling API:", error);
        }
    };

    useEffect(() => {
        if (!idDemande) {
            const token = generateUniqueToken();
            localStorage.setItem("zLawyerDemande", token);
            setIdDemande(token);
        }
        if (!isPolling) {
            // @ts-ignore
            return;
        }

        const startTime = Date.now();
        const interval = setInterval(async () => {
            const elapsedTime = Date.now() - startTime;

            if (success || elapsedTime >= 60000) {
                clearInterval(interval);
                setIsPolling(false);

                const informationsUtilisateurs = await userService.connexionParToken();
                localStorage.setItem("zLawyerIdUtilisateur", informationsUtilisateurs.idUtilisateur ?? informationsUtilisateurs.IdUtilisateur);
                window.location.reload();
            }

            await startLoginWorkflow();
        }, 5000);

        return () => clearInterval(interval);
    }, [isPolling, success]);

    const startPolling = async () => {
        await mailService.demandeAuthentification();
        window.open("https://client.zlawyer.fr/office-login?demande=" + localStorage.getItem("zLawyerDemande"));
        setSuccess(false);
        setIsPolling(true);
    };

    return (
        <div className={styles.root}>
            {success && <div className={styles.message}>Connexion réussie, la page va se recharger ...</div>}
            {!success &&
                <div className={styles.message}>
                    <div>
                        Pour utiliser les compléments zLawyer pour office vous devez vous connecter avec votre compte
                        zLawyer.
                    </div>
                    <br/>
                    <Button appearance="primary" className={styles.validateButton} onClick={startPolling}
                            disabled={isPolling}>
                        Me connecter à zLawyer
                    </Button>
                    <br/>
                    <br/>
                    <Link href="https://www.zlawyer.fr/logiciel-avocats/contact/" target={"_blank"}>
                        Vous n'avez pas encore de compte ? <br/> Contactez-nous !
                    </Link>
                </div>
            }
        </div>
    );
};

export default Connexion;
